import { render, staticRenderFns } from "./EditRegisterUIManage.vue?vue&type=template&id=61cb61b1&scoped=true&"
import script from "./EditRegisterUIManage.vue?vue&type=script&lang=js&"
export * from "./EditRegisterUIManage.vue?vue&type=script&lang=js&"
import style0 from "./EditRegisterUIManage.vue?vue&type=style&index=0&id=61cb61b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb61b1",
  null
  
)

export default component.exports